var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item pb-3 mb-5 border-bottom",
      attrs: { id: "voucher--" + _vm.element.id }
    },
    [
      _c(
        "transition",
        { attrs: { mode: "out-in", name: "slide" } },
        [
          !_vm.isEdit
            ? _c(
                "div",
                { staticClass: "row" },
                [
                  _vm.element.offer
                    ? _c("h2", { staticClass: "col-12" }, [
                        _vm._v(_vm._s(_vm.element.offer))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "col-12" }, [
                    _c("i", { staticClass: "fad fa-calendar-week" }),
                    _vm._v(
                      " Gültig: " +
                        _vm._s(_vm.startDate) +
                        "\n                " +
                        _vm._s(_vm.endDate) +
                        " "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.element.conditions
                    ? _c("div", {
                        staticClass: "col-12",
                        domProps: { innerHTML: _vm._s(_vm.element.conditions) }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.element.code
                    ? _c("div", { staticClass: "col-12 col-md-4 my-3" }, [
                        _c("p", [
                          _c("b", [_vm._v("Gutscheincode:")]),
                          _vm._v(" " + _vm._s(_vm.element.code))
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-4 my-3" }, [
                    _c("p", [
                      _c("b", [_vm._v("Downloads:")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.element.downloads > 0
                              ? _vm.element.downloads
                              : "0"
                          )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.element.media.length > 0
                    ? _c(
                        "div",
                        { staticClass: "col-12 col-md-4 my-3 text-right" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              attrs: {
                                href: _vm.element.media[0].url,
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n                    Gutschein herunterladen "
                              ),
                              _c("i", { staticClass: "fad fa-download" })
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("buttons", {
                    attrs: { isLoading: _vm.isLoading },
                    on: {
                      delete: function($event) {
                        return _vm.deleteItem(_vm.element.id)
                      },
                      edit: function($event) {
                        _vm.isEdit = true
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEdit
            ? _c("buero-form", {
                attrs: {
                  elementValues: this.element,
                  schema: _vm.schema,
                  method: "patch",
                  url: "/api/merchant/vouchers"
                },
                on: { cancel: _vm.cancelEdit, updateItem: _vm.updateItem }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }